window.addEventListener('load', () => {
    openNav();

    const stickyscroll = document.querySelector('.navigation');

	const sticky_relocate = () => {
        // NAV STICKY
        if(jQuery(window).scrollTop() > (window.screen.height*0.05) ) {
            stickyscroll.classList.add('sticky');
        } else {
            stickyscroll.classList.remove('sticky');
        }
	}

	if(stickyscroll) {
		jQuery(window).scroll(() => sticky_relocate());
		sticky_relocate();
	}
});

const openNav = () => {
    const medium = window.matchMedia('(max-width: 1024px)');
    const nav = document.querySelector('.navigation');
    const navDimensions = document.querySelector('.navigation').getBoundingClientRect();
    const parents = document.querySelectorAll('.navigation__lists--mobile li.menu-item-has-children');

    // Move next element height of the navigation
    // nav.nextElementSibling.style.paddingTop = navDimensions.height*2 + navDimensions.top + 'px';

    // Open nav op medium
    if(medium.matches) {
        document.querySelector('.navigation__toggle').addEventListener('click', (e) => document.body.classList.toggle('menu-expanded'));
        parents.forEach(sub => sub.addEventListener('click', (e) => e.target.classList.toggle('sub-menu--open')));
    }
}
